var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"assistant"},[_c('div',{staticClass:"content"},[_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('img',{attrs:{"src":"https://classoss.zhuokairui.cn/img/dingming/imgs/assistant/icon1.png"}})])],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f4a1b22","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/assistant.vue
// module id = null
// module chunks = 